module.exports = __webpack_public_path__ + "static/media/tipo-pepep-bold.99e24a02.woff2";